import { useState } from "react";
import appConfig from '../Config/appConfig';
import api from '../Api/api';

const url = appConfig.AddressValidationBaseURL;
const useAddressValidation = () => {
  const [error, setError] = useState(null);

  const validateAddress = async (shippingData) => {
    try {
      await api.post(
        `${url}/v1/address-validator`,
        { shippingData }
      );
      setError(null);
      return { isValid: true, error: null };
    } catch (error) {
      let errorMessage = "Address validation failed.";
      if (error.response && error.response.status === 422) {
        errorMessage = error.response.data.message || "Invalid Address.";
      } else {
        errorMessage = "There was an issue validating your address. Please try again.";
      }
      console.error("Address validation error:", errorMessage);
      setError(errorMessage);
      return { isValid: false, error: errorMessage };
    }
  };

  return { error, validateAddress };
};

export default useAddressValidation;
